/**
 * Country to currency mapping. Used as a fallback when the claim link config
 * does not carry explicit `sourceCurrency` / `destinationCurrency` values.
 */
export const COUNTRY_CURRENCY: Record<string, string> = {
  US: "USD",
  MX: "MXN",
  AR: "ARS",
  CO: "COP",
  BR: "BRL",
  UY: "UYU",
  GT: "GTQ",
  CL: "CLP",
  PE: "PEN",
  ES: "EUR",
  DE: "EUR",
  FR: "EUR",
};

/**
 * Best-effort ISO2 from a receive currency. Ambiguous codes (EUR) return the
 * first mapped country — callers should prefer claim/recipient country first.
 */
export const countryFromCurrency = (currency?: string): string | undefined => {
  const upper = currency?.trim().toUpperCase();
  if (!upper) return undefined;
  const match = Object.entries(COUNTRY_CURRENCY).find(([, ccy]) => ccy === upper);
  return match?.[0];
};
